<fury-list>
    <div class="table table_container">
      <table mat-table [dataSource]="dataSource">
        <!-- Successfull Payment History -->
        <ng-container matColumnDef="createdAt">
          <th mat-header-cell *matHeaderCellDef>Transaction Date</th>
          <td mat-cell *matCellDef="let element">
            {{ commonService.convertDate( element?.createdAt)  | date : "MMM-dd-YYYY h:mm a"  }}
          </td>
        </ng-container>

        <ng-container matColumnDef="amount">
            <th mat-header-cell *matHeaderCellDef>Amount</th>
            <td mat-cell *matCellDef="let element">
              {{ element?.amount | currency }}
            </td>
          </ng-container>
          
          <ng-container matColumnDef="transactionId">
            <th mat-header-cell *matHeaderCellDef>Transaction Id</th>
            <td mat-cell *matCellDef="let element">
              {{ element?.transactionId }}
            </td>
          </ng-container>
          <ng-container matColumnDef="bankName">
            <th mat-header-cell *matHeaderCellDef>Bank Name</th>
            <td mat-cell *matCellDef="let element">
              {{ element?.bankDetails?.bankName }}
            </td>
          </ng-container>
  
          <ng-container matColumnDef="nameOnAccount">
            <th mat-header-cell *matHeaderCellDef>Name On Account</th>
            <td mat-cell *matCellDef="let element">
              {{ element?.bankDetails?.nameOnAccount }}
            </td>
          </ng-container>
          <ng-container matColumnDef="cardType">
            <th mat-header-cell *matHeaderCellDef>Card Type</th>
            <td mat-cell *matCellDef="let element">
              {{ element?.cardType }}
            </td>
          </ng-container>
          <ng-container matColumnDef="cardLastFourDigit">
            <th mat-header-cell *matHeaderCellDef>Card Last Four Digit</th>
            <td mat-cell *matCellDef="let element">
              {{ element?.cardLastFourDigit }}
            </td>
          </ng-container>

            <!-- Upcomming Payment History -->

            <ng-container matColumnDef="dueDate">
                <th mat-header-cell *matHeaderCellDef>Due Date</th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.dueDate | date : "MMM-dd-YYYY"  }}
                </td>
              </ng-container>
      
              <ng-container matColumnDef="amountPaid">
                  <th mat-header-cell *matHeaderCellDef>Amount Paid</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element?.amountPaid | currency }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="installmentNumber">
                    <th mat-header-cell *matHeaderCellDef>Installment Number</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element?.installmentNumber }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="remainingAmount">
                    <th mat-header-cell *matHeaderCellDef>Remaining Amount</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element?.remainingAmount | currency }}
                    </td>
                  </ng-container>

                   <!-- Upcomming Payment History -->

                   <ng-container matColumnDef="category">
                    <th mat-header-cell *matHeaderCellDef>Category</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element?.category }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="agreementNumber">
                    <th mat-header-cell *matHeaderCellDef>Agreement Number</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element?.agreementNumber }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="claimNumber">
                    <th mat-header-cell *matHeaderCellDef>Claim Number</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element?.claimNumber }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="chargeManuallyAmount">
                    <th mat-header-cell *matHeaderCellDef>Amount</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element?.amount | currency }}
                    </td>
                  </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      <div
        *ngIf="!dataSource?.length"
        style="padding: 10px 0; text-align: center"
      >
        No data found.
      </div>
    </div>
  </fury-list>
  